import { render, staticRenderFns } from "./SurveyCreate.vue?vue&type=template&id=04a8b375"
import script from "./SurveyCreate.vue?vue&type=script&lang=js"
export * from "./SurveyCreate.vue?vue&type=script&lang=js"
import style0 from "./SurveyCreate.vue?vue&type=style&index=0&id=04a8b375&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports